<template>
    <b-container fluid>
        <header-buttons
                :buttons="headerButtons"
                @onMatchWizard="$router.push({name: 'society.matches.wizard'})"
        ></header-buttons>
        <b-row>
            <b-col cols="12">
                <h3 class="text-primary text-uppercase">Disponibili per richieste</h3>
                <hr>
                <b-row v-if="availableMatches.length">
                    <b-col cols="12" md="4" class="mb-4"
                           v-for="(match, index) in availableMatches" v-bind:key="index">
                        <society-dash-match-container :match="match"></society-dash-match-container>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="12" class="mb-4">
                        <b-alert variant="warning" show>
                            Non sono disponibili partite al momento
                        </b-alert>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12">
                <h3 class="text-primary text-uppercase">Con richieste In corso</h3>
                <hr>
                <b-row v-if="pendingRequests.length">
                    <b-col cols="12" md="4" class="mb-4"
                           v-for="(request, index) in pendingRequests" v-bind:key="index">
                        <society-dash-request-container
                                @onClick="openRequestDetail"
                                :matchRequest="request"></society-dash-request-container>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="12" class="mb-3">
                        <b-alert variant="warning" show>
                            Non ci sono richieste in corso
                        </b-alert>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12">
                <h3 class="text-primary text-uppercase">Storico</h3>
                <hr>
                <b-row v-if="historyRequests.length">
                    <b-col cols="12" md="4" class="mb-4"
                           v-for="(request, index) in historyRequests" v-bind:key="index">
                        <society-dash-request-container
                                @onClick="openRequestDetail"
                                :matchRequest="request"></society-dash-request-container>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="12" class="mb-3">
                        <b-alert variant="warning" show>
                            Non ci sono richieste concluse
                        </b-alert>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import {mapActions} from 'vuex';
    import SocietyDashMatchContainer from "../../society-dash/components/SocietyDashMatchContainer/SocietyDashMatchContainer";
    import SocietyDashRequestContainer from "../../society-dash/components/SocietyDashRequestContainer/SocietyDashRequestContainer";
    import CONST from "@/const";

    export default {
        name: "SocietyDashView",
        components: {SocietyDashRequestContainer, SocietyDashMatchContainer, HeaderButtons},
        data() {
            return {
                headerButtons: [
                    {
                        label: 'Nuova Richiesta',
                        onClick: 'onMatchWizard'
                    },
                ],
                availableMatches: [],
                pendingRequests: [],
                historyRequests: []

            }
        },

        mounted() {

            this.societyDashAvailableMatches()
                .then((data) => {
                    this.availableMatches = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento dei match disponibili', {
                    title: 'Alert',
                    variant: 'warning'
                });
            });

            this.societyMatchesGetRequestsByStatus([
                CONST.REQUEST_STATUSES.pending.name,
                CONST.REQUEST_STATUSES.paid.name,
                CONST.REQUEST_STATUSES.warning.name,
            ])
                .then((data) => {
                    this.pendingRequests = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento delle richieste in attesa', {
                    title: 'Alert',
                    variant: 'warning'
                });
            });

            this.societyMatchesGetRequestsByStatus([
                CONST.REQUEST_STATUSES.rejected.name,
                CONST.REQUEST_STATUSES.completed.name,
            ])
                .then((data) => {
                    this.historyRequests = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento delle richieste in attesa', {
                    title: 'Alert',
                    variant: 'warning'
                });
            })
        },
        methods: {

            ...mapActions({
                societyDashUpdateUser: 'societyDashUpdateUser',
                societyDashAvailableMatches: 'societyDashAvailableMatches',
                societyMatchesGetRequestsByStatus: 'societyMatchesGetRequestsByStatus',
                societyMatchesShowRequest: 'societyMatchesShowRequest',
            }),


            openRequestDetail(request) {

                this.societyMatchesShowRequest(request)
                    .then((data) => {
                        this.$router.push({name: 'society.matches.request', params: {id: data.id}})
                    }).catch(() => {
                    this.$bvToast.toast('Problemi nel caricamento della richeista', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })

            }
        }
    }

</script>

<style scoped>

</style>
